var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMicrosoftTeams(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3452 9.9707H22.0279C22.5647 9.9707 23 10.4011 23 10.9321V16.0513C23 18.0028 21.4004 19.5847 19.4273 19.5847H19.4104C17.4372 19.585 15.8374 18.0032 15.8372 16.0518C15.8372 16.0516 15.8372 16.0515 15.8372 16.0513V10.4732C15.8372 10.1957 16.0646 9.9707 16.3452 9.9707Z",
    fill: "#5059C9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.186 8.9583C21.4575 8.9583 22.4883 7.93885 22.4883 6.6813C22.4883 5.42374 21.4575 4.4043 20.186 4.4043C18.9145 4.4043 17.8837 5.42374 17.8837 6.6813C17.8837 7.93885 18.9145 8.9583 20.186 8.9583Z",
    fill: "#5059C9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0232 8.95887C14.8599 8.95887 16.3488 7.48633 16.3488 5.66986C16.3488 3.8534 14.8599 2.38086 13.0232 2.38086C11.1865 2.38086 9.69763 3.8534 9.69763 5.66986C9.69763 7.48633 11.1865 8.95887 13.0232 8.95887Z",
    fill: "#7B83EB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4575 9.9707H8.07734C7.54686 9.98369 7.12722 10.4191 7.13953 10.9437V16.7825C7.06545 19.9309 9.58406 22.5437 12.7674 22.6207C15.9508 22.5437 18.4694 19.9309 18.3954 16.7825V10.9437C18.4076 10.4191 17.988 9.98369 17.4575 9.9707Z",
    fill: "#7B83EB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M13.2791 9.9707V18.1527C13.2765 18.5279 13.0466 18.865 12.6958 19.0079C12.5841 19.0546 12.4641 19.0787 12.3428 19.0787H7.58978C7.52328 18.9117 7.46188 18.7447 7.41071 18.5727C7.23162 17.9921 7.14024 17.3885 7.13955 16.7815V10.9422C7.12725 10.4184 7.5462 9.98369 8.07583 9.9707H13.2791Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M12.7675 9.9707V18.6587C12.7674 18.7787 12.7431 18.8974 12.6958 19.0079C12.5514 19.3548 12.2106 19.5822 11.8312 19.5847H7.83025C7.74327 19.4177 7.66142 19.2507 7.58978 19.0787C7.51815 18.9067 7.46188 18.7447 7.41071 18.5727C7.23162 17.9921 7.14024 17.3885 7.13955 16.7815V10.9422C7.12725 10.4184 7.5462 9.98369 8.07583 9.9707H12.7675Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M12.7675 9.9707V17.6467C12.7636 18.1565 12.3467 18.5689 11.8312 18.5727H7.41071C7.23162 17.9921 7.14024 17.3885 7.13955 16.7815V10.9422C7.12725 10.4184 7.5462 9.98369 8.07583 9.9707H12.7675Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M12.2558 9.9707V17.6467C12.2519 18.1565 11.835 18.5689 11.3195 18.5727H7.41071C7.23162 17.9921 7.14024 17.3885 7.13955 16.7815V10.9422C7.12725 10.4184 7.5462 9.98369 8.07583 9.9707H12.2558Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M13.2791 7.35566V8.94956C13.1921 8.95461 13.1103 8.95968 13.0233 8.95968C12.9363 8.95968 12.8545 8.95462 12.7675 8.94956C12.5948 8.93822 12.4235 8.91113 12.2558 8.8686C11.2198 8.62595 10.3639 7.90734 9.95352 6.93568C9.88291 6.77251 9.8281 6.60308 9.78979 6.42969H12.3428C12.8591 6.43162 13.2771 6.84505 13.2791 7.35566Z",
    fill: "black"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M12.7674 7.86152V8.94942C12.5947 8.93809 12.4235 8.91099 12.2558 8.86846C11.2198 8.62581 10.3638 7.9072 9.95349 6.93555H11.8312C12.3474 6.93748 12.7655 7.35092 12.7674 7.86152Z",
    fill: "black"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M12.7674 7.86152V8.94942C12.5947 8.93809 12.4235 8.91099 12.2558 8.86846C11.2198 8.62581 10.3638 7.9072 9.95349 6.93555H11.8312C12.3474 6.93748 12.7655 7.35092 12.7674 7.86152Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M12.2558 7.86153V8.86846C11.2198 8.62581 10.3638 7.9072 9.95349 6.93555H11.3195C11.8358 6.93749 12.2539 7.35093 12.2558 7.86153Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M1.93781 6.93555H11.318C11.8359 6.93555 12.2558 7.35081 12.2558 7.86304V17.14C12.2558 17.6523 11.8359 18.0675 11.318 18.0675H1.93781C1.41987 18.0675 1 17.6523 1 17.14V7.86304C1 7.35081 1.41988 6.93555 1.93781 6.93555Z",
    fill: "url(#paint0_linear_18640_183418)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M9.09598 10.4659H7.22085V15.5158H6.02621V10.4659H4.15979V9.48633H9.09598V10.4659Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_18640_183418",
    x1: 2.95536,
    y1: 6.21082,
    x2: 10.1793,
    y2: 18.8615,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A62C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#4D55BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3940AB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrosoftTeams);
export default __webpack_public_path__ + "static/media/MicrosoftTeams.c5df5263056378baa0bfd483d9673709.svg";
export { ForwardRef as ReactComponent };